import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/product-thumb-sm.png'


const _hoisted_1 = {
  key: 0,
  class: "product__left"
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 0,
  class: "product__title"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "product__description" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "text-color-um-blue" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 2,
  class: "product__location"
}
const _hoisted_13 = { class: "text-color-um-blue" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "map" }, null, -1)
const _hoisted_15 = { class: "product__right" }
const _hoisted_16 = { class: "product__overview" }
const _hoisted_17 = ["alt"]
const _hoisted_18 = {
  key: 0,
  class: "product__title"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "product__description" }
const _hoisted_22 = { class: "product__list" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "text-color-um-blue" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = {
  key: 3,
  class: "product__accordion"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 0,
  class: "p-2"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "product__list"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 6 }
const _hoisted_38 = {
  key: 0,
  class: "product__actions"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product", !_ctx.compact ? 'product--lg' : ''])
  }, [
    (!_ctx.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("template", null, [
            _createElementVNode("div", {
              class: "product__image",
              style: _normalizeStyle([
            _ctx.state.image ? 'background-image:url(' + _ctx.state.image + ')' : '',
          ])
            }, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: _ctx.data.name
                  }, null, 8, _hoisted_2)
                ]),
                _: 1
              })
            ], 4)
          ]),
          (_ctx.displayLeftContains('name'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.data.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_router_link, { to: "" }, {
                        default: _withCtx(() => [
                          (_ctx.defaultLanguageSelected)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.data.name), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.defaultLanguageSelected)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(_ctx.data.nameEnglish), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("template", null, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, _toDisplayString(_ctx.data.description), 1),
              _hoisted_7
            ])
          ]),
          (_ctx.displayLeftContains('linkList') && _ctx.data.researchEquipmentList[0])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_8, _toDisplayString(_ctx.t("content.researchInfrastructure.content.listOfEquipment")), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.researchEquipmentList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_router_link, {
                        class: "link",
                        to: {
                name: 'research-equipment-detail',
                params: { id: item.id },
              }
                      }, {
                        default: _withCtx(() => [
                          (_ctx.defaultLanguageSelected)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(item.name), 1))
                            : _createCommentVNode("", true),
                          (!_ctx.defaultLanguageSelected)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(item.nameEnglish), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128)),
                (!_ctx.data.researchEquipmentList.length)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.displayLeftContains('location') && _ctx.data.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.t("content.researchInfrastructure.content.locationTitle")), 1)
                ]),
                _hoisted_14
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_ctx.data)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product__image",
              style: _normalizeStyle([
              _ctx.state.image ? 'background-image:url(' + _ctx.state.image + ')' : '',
            ])
            }, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: _ctx.data.title
                  }, null, 8, _hoisted_17)
                ]),
                _: 1
              })
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.displayContains('name'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.data.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_component_router_link, { to: "" }, {
                      default: _withCtx(() => [
                        (_ctx.defaultLanguageSelected)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_19, _toDisplayString(_ctx.data.name), 1))
                          : _createCommentVNode("", true),
                        (!_ctx.defaultLanguageSelected)
                          ? (_openBlock(), _createElementBlock("h3", _hoisted_20, _toDisplayString(_ctx.data.nameEnglish), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", null, _toDisplayString(_ctx.data.description), 1)
        ]),
        (_ctx.displayContains('infoList') && _ctx.data.infoList)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.data.infoList, (list, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", _hoisted_22, [
                  (list.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                        _createElementVNode("strong", _hoisted_24, _toDisplayString(list.title), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (list.children)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.children, (child, index_child) => {
                          return (_openBlock(), _createElementBlock("p", { key: index_child }, [
                            _createVNode(_component_IconTextBlock, {
                              icon: child.icon,
                              label: child.label,
                              to: child.to,
                              href: child.href
                            }, null, 8, ["icon", "label", "to", "href"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_26
              ], 64))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.state.researchInfrastructureParts)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", null, [
                _createVNode(_component_Accordion, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.researchInfrastructureParts, (item, index) => {
                      return (_openBlock(), _createBlock(_component_AccordionTab, {
                        key: index,
                        header: item
                      }, {
                        default: _withCtx(() => [
                          (index === 'entity' && _ctx.data.contactUsers[0])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (_ctx.data.contactUsers[0])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_IconTextBlock, {
                                          icon: "icon-user",
                                          label: `${_ctx.data.contactUsers[0].firstname} ${_ctx.data.contactUsers[0].lastname}`
                                        }, null, 8, ["label"])
                                      ]),
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_IconTextBlock, {
                                          icon: "icon-phone",
                                          label: _ctx.data.contactUsers[0].phoneNumber
                                        }, null, 8, ["label"])
                                      ]),
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_IconTextBlock, {
                                          icon: "icon-envelope-3",
                                          label: _ctx.data.contactUsers[0].email
                                        }, null, 8, ["label"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (index === 'entity' && !_ctx.data.contactUsers[0])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.t(
                          "content.researchInfrastructure.content.loginToViewData"
                        )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (index === 'groups' && _ctx.data.researchGroups[0])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_ctx.data.researchGroups[0])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.researchGroups, (item, index) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: item.id
                                        }, [
                                          _createVNode(_component_IconTextBlock, {
                                            class: "mt-1",
                                            style: {"cursor":"pointer"},
                                            icon: "pi pi-users",
                                            label: item.displayName,
                                            onClick: ($event: any) => (_ctx.toggleGroupUsers(index))
                                          }, null, 8, ["label", "onClick"]),
                                          _hoisted_31,
                                          (_ctx.state.userGroupIndex == index)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.users, (user) => {
                                                return (_openBlock(), _createElementBlock("p", {
                                                  key: user.id
                                                }, [
                                                  _createVNode(_component_IconTextBlock, {
                                                    class: "ml-5",
                                                    icon: "pi pi-user",
                                                    label: ` ${user.firstname} ${user.lastname}`
                                                  }, null, 8, ["label"])
                                                ]))
                                              }), 128))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (index === 'groups' && !_ctx.data.researchGroups[0])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.t(
                          "content.researchInfrastructure.content.loginToViewData"
                        )), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (index === 'organization')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                (_ctx.data.researchOrganization)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_IconTextBlock, {
                                          icon: "icon-pin",
                                          label: `${
                            _ctx.defaultLanguageSelected
                              ? `${_ctx.data.researchOrganization.name} <br/> ${_ctx.data.location.street} <br/> ${_ctx.data.location.postalCode}`
                              : `${_ctx.data.researchOrganization.nameEnglish} <br /> ${_ctx.data.location.street} <br /> ${_ctx.data.location.postalCode}`
                          }`,
                                          href: _ctx.data.researchOrganization.id
                                        }, null, 8, ["label", "href"])
                                      ]),
                                      _createElementVNode("p", null, [
                                        _createVNode(_component_IconTextBlock, {
                                          icon: "pi pi-link",
                                          label: _ctx.data.researchOrganization.websiteURL,
                                          href: _ctx.data.researchOrganization.id
                                        }, null, 8, ["label", "href"])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (index === 'listOfEquipment')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (
                        _ctx.displayContains('linkList') &&
                        _ctx.data.researchEquipmentList[0]
                      )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.researchEquipmentList, (item, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                          _createElementVNode("p", null, [
                                            _createVNode(_component_router_link, {
                                              class: "link",
                                              to: {
                                name: 'research-equipment-detail',
                                params: { id: item.id },
                              }
                                            }, {
                                              default: _withCtx(() => [
                                                (_ctx.defaultLanguageSelected)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(item.name), 1))
                                                  : _createCommentVNode("", true),
                                                (!_ctx.defaultLanguageSelected)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(item.nameEnglish), 1))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 2
                                            }, 1032, ["to"])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (
                      index === 'organization' && !_ctx.data.researchOrganization
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.t(
                          "content.researchInfrastructure.content.loginToViewData"
                        )), 1)
                              ]))
                            : (index === 'location')
                              ? (_openBlock(), _createBlock(_component_GoogleMapsSmall, {
                                  key: 7,
                                  location: _ctx.state.locationData
                                }, null, 8, ["location"]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["header"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _hoisted_39,
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}